import React from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { Form } from "react-bootstrap";

import { MdArrowDownward } from "react-icons/md";

const sortIcon = <MdArrowDownward />;
const selectProps = { indeterminate: (isIndeterminate) => isIndeterminate };
createTheme(
  "solarized",
  {
    text: {
      primary: "#333",
      secondary: "#555",
    },
    background: {
      default: "#f5f5f5",
    },
    context: {
      background: "#ffa07a",
      text: "#333",
    },
    divider: {
      default: "#ddd",
    },
    button: {
      default: "#3498db",
      hover: "rgba(0, 0, 0, .08)",
      focus: "rgba(0, 0, 0, .1)",
      disabled: "rgba(0, 0, 0, .2)",
    },
    sortFocus: {
      default: "#3498db",
    },
  },
  "light"
);
function DataTableBase(props) {
  return (
    <DataTable
      // subHeader
      // subHeaderAlign="right"
      // subHeaderWrap
      persistTableHead
      pagination
      selectableRowsComponent={Form.Check}
      // selectableRowsComponentProps={selectProps}
      sortIcon={sortIcon}
      dense
      theme="solarized"
      {...props}
    />
  );
}

export default DataTableBase;
